import type { NoticeGeneralHistoryItem, NoticeHistoryItem } from './types';

export const isGeneralHistoryNotice = (value: unknown): value is NoticeGeneralHistoryItem => {
  if (value === null || typeof value !== 'object') {
    return false;
  }

  return 'acknowledgedSummary' in value;
};

export const isMyHistoryNotice = (value: unknown): value is NoticeHistoryItem => {
  if (value === null || typeof value !== 'object') {
    return false;
  }

  return 'acknowledged' in value;
};
